// Apparently it is really hard to check if a slot contains stuff under certain circumstances
// https://github.com/vuejs/core/issues/4733

import { Comment, Fragment, Text, type Slot, type VNode } from 'vue';

export function hasSlotContent(slot: Slot | undefined | null, props: any = {}): boolean {
	return !isSlotEmpty(slot, props);
}

export function isSlotEmpty(slot: Slot | undefined | null, props: any = {}): boolean {
	return isVNodeEmpty(slot?.(props));
}
export function asArray<T>(arg: T | T[] | null): T[] {
	return Array.isArray(arg) ? arg : arg !== null ? [arg] : [];
}

export function isVNodeEmpty(vnode: VNode | VNode[] | undefined | null): boolean {
	return (
		!vnode ||
		asArray(vnode).every(
			(vnode) =>
				vnode.type === Comment ||
				(vnode.type === Text && !vnode.children?.length) ||
				(vnode.type === Fragment && !vnode.children?.length)
		)
	);
}
